<ng-content></ng-content>

<cm-inspector-section>
    <ng-container cm-title> Mesh Curve </ng-container>
    <ng-container cm-content>
        <cm-value-slot [node]="$node()" [key]="'mesh'" [label]="'Base Mesh'"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'resolution'" [label]="'Resolution (cm)'"></cm-value-slot>
        @if ($mesh()) {
            <cm-input-container>
                <ng-container cm-inline-label>
                    <div class="cm-label">
                        <div class="cm-value-title">Coordinate space:</div>
                    </div>
                </ng-container>
                <ng-container cm-input>
                    <div class="cm-edit-section">
                        <i [class]="'far fa-cog cm-accepts-icon'"></i>
                        <cm-string-input
                            class="cm-input-container"
                            [value]="$coordinateSpace()?.name ?? ''"
                            [readonly]="true"
                            [isButton]="true"
                            [matMenuTriggerFor]="$canSetCoordinateSpace() ? coordinateSpacePossibilitiesMenu : null"
                            [matTooltip]="$canSetCoordinateSpace() ? 'Select' : 'Selection locked'"
                        >
                        </cm-string-input>
                    </div>
                </ng-container>
            </cm-input-container>
        }
    </ng-container>
</cm-inspector-section>

<cm-button class="cm-action-button" (click)="addPoint()" [disabled]="!$mesh() || sceneManagerService.$watchingForClickedSceneNodePart()">
    <ng-container cm-text> Add Point </ng-container>
</cm-button>

@if ($controlPoints().length > 0) {
    <cm-inspector-section>
        <ng-container cm-title>Control Points </ng-container>
        <ng-container cm-content>
            @for (_ of $controlPoints(); track $index) {
                <cm-value-slot
                    [node]="$node()"
                    [key]="'controlPoints'"
                    [subKey]="[$index, 'corner']"
                    [label]="'Corner Point (' + ($index + 1) + ')'"
                    [schema]="$booleanSchema()"
                    (mouseenter)="onMouseEnter($index)"
                    (mouseleave)="onMouseLeave()"
                ></cm-value-slot>
            }
            <cm-value-slot [node]="$node()" [key]="'closed'" [label]="'Close Path'"></cm-value-slot>
        </ng-container>
    </cm-inspector-section>

    <cm-button class="cm-action-button" (click)="deletePoints()" [disabled]="!$mesh() || sceneManagerService.$watchingForClickedSceneNodePart()">
        <ng-container cm-text> Delete </ng-container>
    </cm-button>
}

<mat-menu #coordinateSpacePossibilitiesMenu="matMenu">
    @if ($coordinateSpacePossibilities(); as coordinateSpacePossibilities) {
        @for (coordinateSpacePossibility of coordinateSpacePossibilities; track coordinateSpacePossibility.name) {
            <cm-list-item (click)="setCoordinateSpace(resolveSelectionPossibilityValue(coordinateSpacePossibility.value))">
                <ng-container cm-pre-title><i class="far fa-cog"></i></ng-container>
                <ng-container cm-title>{{ coordinateSpacePossibility.name }}</ng-container>
            </cm-list-item>
        }
    }
</mat-menu>
